// SweetAlert2 import for Vue (ESM)
import Swal from 'sweetalert2';
export default Swal;
